
  import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
  import PageFooter from '@/components/page-footer.vue';
	import Message from '@/components/message.vue';
  import {
    productproductClassDel
  } from "@/api/order"
  @Component({  
    name: '',
    components: {
      PageFooter,
      'slz-message':Message,
    }
  })

  export default class ProductList extends Vue {
    @Prop({default:false,}) show:boolean
    @Prop({default:()=>{
      return {}
    }}) row:any
    private msgShow = false

    @Watch('show')
    private watchShow(val){
      this.msgShow = val
    }



    private async confirm(){
      try{
        let res = await productproductClassDel({
          Id:this.row.Id
        })
        if(res.IsSuccess){
          this.$message.success('操作成功')
          this.$emit('confirm')
        }
      }finally{
        this.cancel()
      }
    }
    private cancel(){
      this.msgShow = false
      this.$emit('cancel',false)
    }
  }
